module.exports = __webpack_public_path__ + "img/16.2ab9aed1.png";